<!-- eslint-disable -->
<template lang="pug">
    .row.trainer-main
        .col-xl-6.trainer-main__column.trainer-main__column--hidden-touch
            .trainer-main__image
                img.trainer-main__clevik(:src='image')
        .col-xs-12.col-xl-6.trainer-main__column
            .trainer-main__menu(v-if="user")
                .menu__header
                    | {{ $i18n.t('trainer.trainer_main_header') }}
                .menu__clever
                    img(src='../../assets/images/trainer/clever.png')
                .menu__body(v-if="user.type === 'student'")
                    template(v-if='homeworks')
                        .menu__button(v-if='uncompletedHomeworkParams',)
                            cs-button(
                                @click="$router.push({\
                                  name: 'browse:game',\
                                  params: {\
                                  exerciseId: uncompletedHomeworkParams.id,\
                                  homeworkId: homeworkId,\
                                  type: routeGameType\
                                }})",
                                :disabled='areSchoolsBlocked || !isBeforeCurrentDate(homeworks[0])',
                                :full-width="true"
                                color="blue"
                            )
                                | {{ $i18n.t('trainer.trainer_main_homework') }}
                        .menu__button
                            cs-button(
                                @click="$router.push({name: 'trainer:games'})",
                                :disabled='areSchoolsBlocked || hasUncompletedHomeworks',
                                :full-width="true"
                                color="blue"
                            )
                                | {{ $i18n.t('trainer.trainer_main_freeGame') }}
                    cs-loader(v-else='')
                .menu__body(v-else-if="user.type !== 'olympiads-student'")
                    .menu__button(v-if='isShowButtonCreateOlymp')
                        cs-button(
                            @click="$router.push({name: 'olympiads:create'})"
                            :full-width="true"
                            color="blue"
                        )
                            | {{ $i18n.t('trainer.trainer_main_createOlympiad') }}
                    .menu__button
                        cs-button(
                            @click="$router.push({name: 'homework:create', params: {type: 'homework'}})",
                            :disabled='areSchoolsBlocked',
                            :full-width="true"
                            color="blue"
                        )
                            | {{ $i18n.t('trainer.trainer_main_createHomework') }}
                    .menu__button
                        cs-button(
                            @click="$router.push({name: 'trainer:games'})",
                            :disabled='areSchoolsBlocked'
                            :full-width="true"
                            color="blue"
                        )
                            | {{ $i18n.t('trainer.trainer_main_lessonConducting') }}
                    .menu__button(v-if="user.pointsAccesses.includes('mentalArithmetic')")
                        cs-button(
                            @click="$router.push({name: 'trainer:generator'})"
                            :disabled='areSchoolsBlocked || isFreeTariff'
                            :full-width="true"
                            color="blue"
                        )
                            | {{ $i18n.t('trainer.trainer_main_taskGenerator') }}
                        span.menu__hint(v-if="isFreeTariff")
                            tariff-restriction-notice
                                template(v-slot:before)
                                    | {{ $t('trainer.accessDisabled_part1') }}
                                | {{ $t('trainer.accessDisabled_part2') }}
                .menu__body(v-else='')
                    | {{ $i18n.t('trainer.trainer_main_noAccess') }}
                .menu__footer(v-if="!user.isSuperadmin")
                    .menu__button
                        cs-button(
                            @click="$router.push({name: 'dashboard'})"
                            :full-width="true"
                            color="blue"
                            pattern="primary-outline"
                        )
                            | {{ $i18n.t('common.common_navigation_exit') }}
</template>

<script>
    /*eslint-disable*/
    import HomeworkApi from '../../api/homework/homework';

    import TurtleImageRu from '../../assets/images/trainer/turtle-ru.png';
    import TurtleImageBg from '../../assets/images/trainer/turtle-bg.png';
    import TurtleImageFr from '../../assets/images/trainer/turtle-fr.png';

    import BillingBlockMixin from '../../utils/user/BillingBlockMixin';
    import TariffRestrictionNotice from '@/components/tariffs/TariffRestrictionNotice';

    import {mapState} from 'vuex';
    import _ from 'lodash';
    import moment from 'moment';
    import { TARIFF_IDS_WITH_GENERATOR_DISABLED } from '@/config/tariff_constants';

    export default {
        mixins: [BillingBlockMixin],
        components: {
            TariffRestrictionNotice,
        },
        data() {
            return {
                isLoading: false,
                homeworks: null,
                serverDate: "",
                homeworkId: -1,
                uncompletedHomeworkParams: null,
            }
        },
        mounted() {
            this.fetchData();
        },
        methods: {
            getType (slug) {
                if (slug.indexOf('FlashCards') !== -1) {
                    return 'FlashCards';
                } else if (slug.indexOf('AdditionAndSubtraction') !== -1) {
                    return 'AdditionAndSubtraction';
                } else if (slug.indexOf('MultiplicationAndDivision') !== -1) {
                    return 'MultiplicationAndDivision';
                }
                return slug;
            },
            fetchData() {
                this.isLoading = true;
                HomeworkApi.uncompletedHomework().then(response => {
                    this.homeworks = _.orderBy(response.homeworks, 'date');
                    if (this.homeworks.length > 0) {
                        let homework = this.homeworks[0];
                        this.serverDate = response.serverDate;
                        this.homeworkId = homework.id;
                        for (let i = 0; i < homework.exercises.length; i++) {
                            let item = homework.exercises[i];
                            if (!item.isCompleted) {
                                this.uncompletedHomeworkParams = {
                                    id: item.id,
                                    slug: item.slug,
                                    parameters: item.parameters.default
                                };
                                break;
                            }
                        }
                    }
                    this.isLoading = false;
                }).catch(() => {
                    this.isLoading = false;
                })
            },
            isBeforeCurrentDate(homework) {
                return !moment(this.serverDate).isBefore(moment(homework.dateAsIsoString));
            },
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
                selectedCourse: state => state.trainer.course
            }),
            isFreeTariff() {
                return TARIFF_IDS_WITH_GENERATOR_DISABLED.includes(this.user.schools[0].tariffId) &&
                    this.user.type === 'teacher';
            },
            image () {
                switch (this.$i18n.locale) {
                    case 'ru': return TurtleImageRu;
                    case 'bg': return TurtleImageBg;
                    case 'fr': return TurtleImageFr;
                    default: return TurtleImageRu;
                }
            },
            routeGameType () {
                if (this.uncompletedHomeworkParams.parameters.withTime) {
                    return this.uncompletedHomeworkParams.slug + 'WithTime';
                }
                return this.uncompletedHomeworkParams.slug;
            },
            hasUncompletedHomeworks () {
                return this.homeworks.some(homework => {
                    return !homework.isBlocked
                            && homework.exercises[0].courseType === _.kebabCase(this.selectedCourse);
                });
            },
            isShowButtonCreateOlymp () {
                return this.user.isSuperadmin || this.user.isManagerOrSupport;
            },
        },
    }
</script>

<style lang="scss" scoped>
    .trainer-main {
        margin: 0;
        height: 100%;
    }

    .trainer-main__column {
        height: 100%;
        padding: 0;
        @include media($sm) {
            padding: 0 20px;
        }
    }

    .trainer-main__column:last-child {
        @include media($sm) {
            padding: 0 0 0 20px;
        }
    }

    .trainer-main__column--hidden-touch {
        display: none;
        @include media($xlg) {
            display: block;
        }
    }

    .trainer-main__image {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .trainer-main__clevik {
        width: 100%;
        max-width: 530px;
    }

    .trainer-main__menu {
        margin: 0;
        height: 100%;
        background-color: $x-color-white;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        @include media($sm) {
            padding: 15px;
            border-radius: $border-radius-40;
        }
    }

    .menu__header {
        font-weight: 500;
        font-size: 32px;
        line-height: 40px;

        text-align: center;

        color: $hsl-color-green-58;

        margin-bottom: 20px;
    }

    .menu__header, .menu__body, .menu__footer {
        width: 100%;
        max-width: 310px;
    }

    .menu__body, .menu__footer {
        display: flex;
        flex-direction: column;
    }

    .menu__body {
        margin: -10px 0 5px;
    }

    .menu__clever {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 30px;
    }

    .menu__button {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 10px;
    }

    .menu__hint {
        font-size: 12px;
        color: #999;
        margin-top: 4px;
        text-align: center;
    }
</style>
